import { createSubsetSelector } from 'webui/utils/selectors';
export const legacy_heating_modes_config = createSubsetSelector(['id', 'thermostat_ext_modes_config']);
export const legacy_heating_mode_state = createSubsetSelector(['id', 'thermostat_ext_mode', 'thermostat_target_temps']);
